import React from 'react';
import Link from 'next/link';
import { getAppRelease } from '../actions';
import { RETURN_KEY, validRelease, readKey, readStored, store, browserStorage } from '../lib/release-notice';

export default class ReleaseNotice extends React.Component {
  state = { release: null, updateAvailable: false, unread: false };
  baseline = null;
  alive = false;
  checking = false;

  readStatus = () => {
    const id = this.props.auth?._id;
    const revision = this.state.release?.instructionsRevision;
    const unread = Boolean(id && revision && readStored(browserStorage(window, 'localStorage'), readKey(id)) !== revision);
    if (unread !== this.state.unread) this.setState({ unread });
  };

  checkRelease = async () => {
    if (!this.alive || this.checking) return;
    this.checking = true;
    try {
      const release = await getAppRelease();
      if (!this.alive || !validRelease(release)) return;
      const changed = release.version !== this.props.version || Boolean(this.baseline && release.releaseKey !== this.baseline.releaseKey);
      if (!this.baseline) this.baseline = release;
      this.setState({ release, updateAvailable: this.state.updateAvailable || changed }, this.readStatus);
    } catch { /* Offline checks leave the current notice intact and retry later. */ }
    finally { this.checking = false; }
  };

  foreground = () => { if (document.visibilityState === 'visible') this.checkRelease(); };
  componentDidMount() {
    this.alive = true;
    this.checkRelease();
    this.interval = setInterval(this.checkRelease, 120000);
    document.addEventListener('visibilitychange', this.foreground);
    window.addEventListener('focus', this.foreground);
    window.addEventListener('mycrashpro-release-check', this.checkRelease);
    window.addEventListener('mycrashpro-instructions-read', this.readStatus);
    window.addEventListener('storage', this.readStatus);
  }
  componentDidUpdate(previous) {
    if (previous.auth?._id !== this.props.auth?._id) this.readStatus();
  }
  componentWillUnmount() {
    this.alive = false;
    clearInterval(this.interval);
    document.removeEventListener('visibilitychange', this.foreground);
    window.removeEventListener('focus', this.foreground);
    window.removeEventListener('mycrashpro-release-check', this.checkRelease);
    window.removeEventListener('mycrashpro-instructions-read', this.readStatus);
    window.removeEventListener('storage', this.readStatus);
  }
  refreshAndRead = () => {
    if (this.props.auth?._id) store(browserStorage(window, 'sessionStorage'), RETURN_KEY, String(this.props.auth._id));
    // Full navigation gets current HTML/assets and opens instructions in one action.
    // The authenticated page preserves this destination across an expired login.
    window.location.assign('/instructions?updated=1');
  };
  render() {
    const signedIn = Boolean(this.props.auth?._id);
    return <div className="release-notices d-print-none">
      {this.state.updateAvailable && <button type="button" className="release-update-bar" onClick={this.refreshAndRead}>
        <strong>HEY — an update is available!</strong>{' '}Finish or copy unsaved work, then tap to refresh and see what changed.
      </button>}
      {signedIn && !this.state.updateAvailable && this.state.unread && <Link href="/instructions" className="release-update-bar">
        <strong>New instructions and changes</strong>{' '}Open Instructions &amp; Training.
      </Link>}
      {signedIn && this.state.release?.readOnly && <div className="recovery-mode-notice" role="status">
        <strong>Recovery mode — viewing only.</strong>{' '}Saving, uploads and external integrations are paused.
      </div>}
    </div>;
  }
}
